import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { SlideShowComponent } from '../slide_show/slide-show.component';
import { Router } from '@angular/router';
import { Title,Meta } from '@angular/platform-browser';

@Component({
  selector: 'app-experts-in',
  templateUrl: './experts-in.component.html',
  styleUrls: ['./experts-in.component.css']
})
export class ExpertsInComponent implements OnInit {
  slidenumber: number = 0;
  slidecolour: number = 0;
  constructor(private router: Router,private titleServvice:Title,private metaService: Meta) { }
  @ViewChild(SlideShowComponent, { static: true, read: ElementRef }) SlideShowComponent!: ElementRef;
  ngOnInit(): void {
    // this.titleServvice.setTitle('Expert IN')
  }
  scrolltoComponent(SlideNumber: number) {
    this.slidenumber = SlideNumber;
    this.SlideShowComponent.nativeElement.scrollIntoView({ behavior: 'smooth' });
  }
  navigateToFeature(index: number): void {
    const selectedFeature = this.features[index];
    if (selectedFeature && selectedFeature.route) {
      this.router.navigate([selectedFeature.route]);
    }
  }
  features = [
    {
      image: '/assets/features/digital_marketing.svg',
      header: 'Digital Marketing',
      description: 'Boost your online presence with our targeted digital marketing solutions. We craft campaigns using social media, email marketing, and analytics to drive measurable results. Reach the right audience, build engagement, and achieve your growth goals.',
      route: 'digital-marketing'
    },
    {
      image: '/assets/features/website_development.svg',
      header: 'Website Development',
      description: 'We develop responsive, user-friendly websites tailored to your business needs. From seamless functionality to engaging designs, our websites ensure a top-tier experience. Drive growth with a platform built to showcase your brand effectively.',
       route: 'website-development'
    },
     {
      image: '/assets/features/seo.svg',
      header: 'SEO & Content Writing',
      description: 'Enhance your online visibility with our SEO and content writing services. We create optimized, high-quality content that ranks and resonates with your audience. Turn searches into visits and visits into loyal customers.',
       route: 'seo'
    },
     {
      image: '/assets/features/uiux.svg',
      header: 'UI & UX Design',
      description: 'Create seamless, visually appealing interfaces with our UI and UX design services. We prioritize user satisfaction through intuitive designs that enhance interaction. Build lasting engagement with designs that work effortlessly.',
       route: 'UI-UX'
    },
     {
      image: '/assets/features/video_editing.svg',
      header: 'Video Editing',
      description: 'Transform your raw footage into professional, engaging videos with our editing services. From storytelling to visual effects, we deliver content that captivates your audience. Elevate your brand with high-quality videos that stand out.',
       route: 'video-editing'
    },
     {
      image: '/assets/features/graphic.svg',
      header: 'Graphic Design',
      description: 'Our graphic design services bring your brand to life with creative and impactful visuals. From eye-catching logos to stunning marketing materials, we craft designs that captivate. Align your visual identity with your brand’s message to leave a lasting impression.',
      route: 'graphic-editing'
    },
  ]
}
